import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { usePermissions } from "../../contexts/PermissionContext";
import { resolveFirstAccessibleRoute } from "../../utils/routeUtils";
import { P } from "../permissions";
import PermissionLoader from "./PermissionLoader";

/**
 * Guard for the "/" index route.
 *
 * Renders the nested route when the user has P.Home.View. Otherwise redirects
 * to the first sidenav feature the user can access (falling back to
 * /unauthorized when nothing is allowed).
 */
const HomeRedirect = () => {
  const { hasPermission, loading } = usePermissions();

  if (loading) return <PermissionLoader>{null}</PermissionLoader>;
  if (hasPermission(P.Home.View)) return <Outlet />;

  return <Navigate to={resolveFirstAccessibleRoute(hasPermission)} replace />;
};

export default HomeRedirect;
